import { GridColDef } from "@mui/x-data-grid";

export const clientCurrentTasksColumns: GridColDef[] = [
  {
    field: "plant_name",
    headerName: "Anlage",
    flex: 1,
  },
  {
    field: "created_by",
    headerName: "Aufgabenersteller",
    flex: 1,
  },
  {
    field: "sub_task_type",
    headerName: "Aufgabenart",
    flex: 1.1,
  },
  {
    field: "due_date",
    headerName: "Enddatum",
    flex: 1,
  },
];

export const clientDisturbancesColumns: GridColDef[] = [
  {
    field: "building_name",
    headerName: "Gebäude",
    flex: 1,
  },
  {
    field: "plant_name",
    headerName: "Anlage",
    flex: 1,
  },

  {
    field: "when",
    headerName: "Aufgetreten am",
    flex: 1,
  },
];
